import { LinkWithBackgroundComponent } from '../../../links/linkWithBackgroundComponent';
import { useLang } from '../../../../hooks/useLang';
import { useEffect, useState } from 'react';
// import simp from '../../../../assets/simplify.png';
import simp from '../../../../assets/brain.svg';
import './simplify.css';

export function Simplify(){

    const {currentLanguage} = useLang();
    const [buttonText, setButtonText] = useState('Free consultation');
    const [sectionText, setSectionText] = useState([]);

    useEffect(() => {
        if (currentLanguage === 'EN'){
            setButtonText('Free consultation');
            setSectionText(['From AI Experiments<br/>to <span class="color-blue">Operating Intelligence.</span>', 'Strategic AI Infrastructure for growing organizations.', "[We design structured transformation: how organizations think, decide, govern and operate with Artificial Intelligence — beyond tools and experiments.]"])
        } else if (currentLanguage === 'UK') {
            setButtonText('Запланувати консультацію');
            setSectionText(['Від AI-експериментів<br/>до <span class="color-blue">Operating Intelligence.</span>', 'Стратегічна AI-інфраструктура для зростаючих організацій.', "[Ми проєктуємо структурну трансформацію: як організація мислить, ухвалює рішення, управляє та працює з AI — поза інструментами й хаотичними впровадженнями.]"])
        }
    }, [currentLanguage]);

    const getInTouchData = {"url": "https://calendly.com/anna-daliuk-tenetix/ai-adoption-and-strategy-intro", "text": buttonText}

    return(
        <div className="simplify-section">
            <div className='simplify-main-container main-container' style={{backgroundImage:simp}}>
                <div className='simplify-text-container'>
                    <h2 dangerouslySetInnerHTML={{__html: sectionText[0]}}></h2>
                    {/* <p className='simplify-description_text' dangerouslySetInnerHTML={{__html: sectionText[1]}}></p> */}
                    <p className='simplify-description2_text' dangerouslySetInnerHTML={{__html: sectionText[2]}}></p>
                    <LinkWithBackgroundComponent data={getInTouchData} />
                </div>
                <div className='simplify-img-container'>
                    <img src={simp} alt='brain'/>
                </div>
            </div>
        </div>
    );
}